import { useState } from 'react';
import { createInvoice } from '../api';

interface Props {
  productId: string;
  title: string;
  priceStars: number;
  description: string;
  onPaid?: () => void;
}

/**
 * Small in-line paywall: a locked card with a single Buy CTA. Sits inside the
 * page where a paid feature would otherwise render, so the user sees the
 * promise (title + description) and one button.
 */
export function Paywall({ productId, title, priceStars, description, onPaid }: Props) {
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function buy() {
    setLoading(true);
    setErr(null);
    try {
      const { invoiceLink } = await createInvoice(productId);
      const tg = window.Telegram?.WebApp;
      if (tg?.openInvoice) {
        tg.openInvoice(invoiceLink, (status) => {
          if (status === 'paid') onPaid?.();
        });
      } else {
        window.open(invoiceLink, '_blank', 'noopener');
      }
    } catch (e) {
      setErr(String(e));
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="card paywall">
      <div className="paywall-lock" aria-hidden>🔒</div>
      <div className="paywall-title">{title}</div>
      <div className="paywall-desc">{description}</div>
      {err && <div className="muted" style={{ color: 'var(--aspect-chal)', margin: '8px 0' }}>{err}</div>}
      <button className="btn paywall-cta" disabled={loading} onClick={buy}>
        {loading ? '…' : `Odblokuj za ${priceStars} ⭐`}
      </button>
    </div>
  );
}
